import {Layout} from "@adminComponents";
import {useAdminLogin} from "@hook";
import {LoginPage} from "@adminPages";
import React, {useEffect} from "react";
import {AdminRouteApp} from "@navigation";
import {Route, Routes} from "react-router-dom";

export default function AdminNavigation() {
  const {token, getAdminData} = useAdminLogin();

  useEffect(() => {
    getAdminData();
  }, []);

  return (
    <>
      {!token ? (
        <LoginPage />
      ) : (
        <Routes>
          <Route
            path="*"
            element={
              <Layout>
                <AdminRouteApp />
              </Layout>
            }
          />
        </Routes>
      )}
    </>
  );
}
